import api from "../../http";

export default class ApiSlotMachinesList {
  static async getApiSlotMachinesList(url) {
    return api.get(url)
  }
}